import React from 'react';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'gold';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wider transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-patriot-bg hover:scale-[1.02] active:scale-[0.98]';
  const variants = {
    primary: 'bg-patriot-darkRed text-white hover:bg-patriot-red shadow-glow-red hover:shadow-glow-red-lg hover:-translate-y-0.5 focus:ring-patriot-red',
    secondary: 'bg-patriot-blue text-white hover:bg-blue-800 shadow-glow-blue hover:-translate-y-0.5 focus:ring-patriot-blue',
    outline: 'border-2 border-patriot-blue text-patriot-light hover:bg-patriot-blue hover:text-white hover:shadow-glow-blue focus:ring-patriot-blue',
    gold: 'bg-gradient-to-r from-patriot-gold to-patriot-darkGold text-white shadow-glow-gold hover:shadow-glow-gold-lg hover:-translate-y-1 focus:ring-patriot-gold border border-yellow-400/30'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm',
    md: 'px-4 py-2.5 text-sm sm:px-6 sm:py-3 sm:text-base',
    lg: 'px-6 py-3 text-base sm:px-8 sm:py-4 sm:text-lg',
    xl: 'px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg md:px-10 md:py-5 md:text-xl lg:text-2xl'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-13">
      {children}
    </button>;
}